// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const CopyLine = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <path d="M22.78,37.45l-.91-1.51c-.18-.3-.52-.49-.88-.49h-1" />
      <path d="M42,8.65v1.07H8.93c-1.62,0-2.93,1.31-2.93,2.93v18.79h-1.07c-1.62,0-2.93-1.31-2.93-2.93V8.65c0-1.62,1.31-2.93,2.93-2.93h34.14c1.62,0,2.93,1.31,2.93,2.93Z" />
      <path d="M46,12.65v19.86c0,1.62-1.31,2.93-2.93,2.93h-12.08c-.36,0-.7.19-.88.49l-3.68,6.1c-.2.32-.68.32-.88,0l-2.77-4.59-.91-1.51c-.18-.3-.52-.49-.88-.49h-12.06c-1.62,0-2.93-1.31-2.93-2.93V12.65c0-1.62,1.31-2.93,2.93-2.93h34.14c1.62,0,2.93,1.31,2.93,2.93Z" />
      <line x1="12.71" y1="22.01" x2="39.31" y2="22.01" />
      <line x1="12.69" y1="28.5" x2="27.54" y2="28.5" />
      <line x1="12.71" y1="15.51" x2="39.31" y2="15.51" />
    </svg>
  );
};
